import React from 'react';
import {
  Building2,
  CreditCard,
  FileCheck,
  Euro,
  Landmark,
  Users,
  MapPin,
  Scale,
  ClipboardList,
  Award,
  CheckCircle
} from 'lucide-react';

const UseCases = () => {
  const useCases = [
    {
      icon: Building2,
      title: 'Deschidere cont bancar firmă',
      description: 'Băncile solicită certificat constatator pentru verificarea existenței și datelor firmei'
    },
    {
      icon: CreditCard,
      title: 'Credit sau leasing business',
      description: 'Dosarul de creditare necesită certificat constatator recent (max 30 zile vechime)'
    },
    {
      icon: FileCheck,
      title: 'Licitații publice SEAP / SICAP',
      description: 'Document obligatoriu în dosarul de participare la achiziții publice'
    },
    {
      icon: Euro,
      title: 'Fonduri europene / PNRR',
      description: 'Certificat constatator necesar pentru verificare eligibilitate și date oficiale'
    },
    {
      icon: Landmark,
      title: 'Contracte cu statul sau primării',
      description: 'Dovada că firma este activă și autorizată să desfășoare activități'
    },
    {
      icon: Users,
      title: 'Parteneriate și colaborări B2B',
      description: 'Due diligence înainte de semnarea contractelor comerciale'
    },
    {
      icon: MapPin,
      title: 'Înființare punct de lucru',
      description: 'Autoritățile locale pot solicita certificat constatator actualizat'
    },
    {
      icon: Scale,
      title: 'Dosare notariale (cesiuni, vânzări)',
      description: 'Notarul verifică reprezentantul legal și datele societății'
    },
    {
      icon: ClipboardList,
      title: 'Înscriere în registre profesionale',
      description: 'ANRE, ARR, ANAF și alte autorități de reglementare'
    },
    {
      icon: Award,
      title: 'Granturi și ajutoare IMM',
      description: 'Confirmarea datelor firmei în aplicațiile pentru finanțări nerambursabile'
    }
  ];

  return (
    <section id="situatii" className="bg-gradient-to-br from-slate-50 to-gray-100 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            În ce situații ai nevoie de Certificat Constatator?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Certificatul constatator ONRC este solicitat frecvent de bănci, instituții publice și parteneri de afaceri pentru verificarea rapidă a situației juridice a firmei tale.
          </p>
        </div>

        {/* Grid cu carduri */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 lg:gap-6">
          {useCases.map((useCase, index) => {
            const IconComponent = useCase.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl p-5 shadow-sm border border-gray-200
                           hover:shadow-lg hover:border-emerald-300 hover:-translate-y-1
                           transition-all duration-300 ease-out"
              >
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                  <IconComponent className="w-6 h-6 text-emerald-600" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2 text-sm lg:text-base">
                  {useCase.title}
                </h3>
                <p className="text-xs lg:text-sm text-gray-600 leading-relaxed">
                  {useCase.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Footer SEO + CTA */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-full px-6 py-3">
            <CheckCircle className="w-5 h-5 text-emerald-600" />
            <span className="text-sm text-gray-700">
              <strong>Certificatul constatator online</strong> are aceeași valoare juridică precum varianta tipărită — semnat electronic de ONRC
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCases;
